export default "__VITE_ASSET__bb7837ad__"